import moment from 'moment'

const prepareShow = meeting => {
  meeting.meeting_date = moment(meeting.meeting_date, 'YYYYMMDD').format('DD/MM/YYYY')
  return meeting
}

export default {
  prepareShow,
  getMeeting (id) {
    this.loading = true
    this.$http.get('/v1/dweller/meetings/' + id)
      .then((data) => {
        this.meeting = data
        this.loading = false
      })
  },
  searchMeeting () {
    this.$http.get('/v1/dweller/meeting/search')
      .then(({data}) => {
        this.meetings = data
      })
  },
  formatDate (dt) {
    return moment(dt, 'YYYYMMDD').format('DD/MM/YYYY')
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/meeting/details/resources/methods.js